import styled from '@emotion/styled';
import { Title, Text } from 'components';

export const TermsAndConditionsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${({ theme }) => theme.base.spacing[2]};
`;

export const Container = styled.div`
    text-align: center;
    padding: ${({ theme }) => theme.base.spacing[4]};
    margin-bottom: ${({ theme }) => theme.base.spacing[3]};
`;

export const MargedTitle = styled(Title)`
    text-align: center;
    margin-bottom: ${({ theme }) => theme.base.spacing[3]};
`;

export const MargedText = styled(Text)`
    text-align: center;
    margin-bottom: ${({ theme }) => theme.base.spacing[8]};
`;

export const BottomBar = styled.div`
    position: sticky;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0px;
    background-color: ${({ theme }) => theme.base.color.white100};
    padding: ${({ theme }) => theme.base.spacing[4]};
`;
